module.exports = __webpack_public_path__ + "static/media/DocWithBubblesLg.883dbd76.png";